import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelTeamEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelTeamEntity
